import { Country, EnumSchema, FromSchema, ZodDate } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { z } from 'zod';
import {
    FinancialConnectionProviderFieldsGocardlessAgreement,
    FinancialConnectionProviderFieldsGocardlessAgreementSchema,
} from './financial-connection-provider-fields-gocardless.agreement';

export const FinancialConnectionProviderFieldsGocardlessSchema = z
    .object({
        requisitionId: z.string(),
        institutionId: z.string(),
        iban: z.string().optional(),
        agreement: FinancialConnectionProviderFieldsGocardlessAgreementSchema,
        reference: z.string().optional(),
        countries: z.array(EnumSchema(Country)).optional(),
        createdAt: ZodDate,
        currency: EnumSchema(Currency).nullish(),
    })
    .strict();

export class FinancialConnectionProviderFieldsGocardless extends FromSchema(FinancialConnectionProviderFieldsGocardlessSchema) {
    requisitionId: string;
    institutionId: string;
    iban?: string;
    agreement: FinancialConnectionProviderFieldsGocardlessAgreement;
    reference?: string;
    createdAt: Date;
    countries?: Country[];
    currency?: Currency;
}
